export default {
    methods: {
        removeDuplicateObjects(array) {
            return array.filter((currentObj, currentIndex, array) => {
                return array.slice(currentIndex + 1).every(otherObj => !this.areObjectsEqual(currentObj, otherObj));
            });
        },
        areObjectsEqual(obj1, obj2) {
            return JSON.stringify(obj1) === JSON.stringify(obj2);
        },
    },
};
